import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import React , {Component} from 'react';
import firebase from 'firebase';

const database=firebase.database();


class ReporteViajesConductores extends Component{
	
	constructor(props){
		
		super(props);
		this.state={
				
				viajes:[],
				condutores:[],
				clientes:[]
				
			
			
		}		
		this.viajesRef=database.ref().child('Viaje');
		this.empleadoRef=database.ref().child('Empleados').orderByChild('socio').equalTo(firebase.auth().currentUser.uid);
		this.clientesRef=database.ref().child('Clientes');
	}
	
	
	componentDidMount(){
		
		
		this.empleadoRef.once('value',this.gotDataEmpleados,this.errDataEmpleados);
		
		
	}
	
	componentWillMount(){
		
		
		this.empleadoRef.once('value',this.gotDataEmpleados,this.errDataEmpleados);
		
	}
	
	gotDataViajes=(data)=>{
		let newViajes=[];
		
		if(data.val()!==null){
			
			let viaje=data.val();
			let keys=Object.keys(viaje);
			
			
			let empleado='';
			let cliente='';
			
			
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i];
				
				for(let j=0;j<this.state.condutores.length;j++){
					
					if(this.state.condutores[j].key===viaje[k].empleado){
						
						empleado=this.state.condutores[j].nombre;
						
					}
					
				}
				
				
				for(let h=0;h<this.state.clientes.length;h++){
					
					if(this.state.clientes[h].key===viaje[k].cliente){
						
						cliente=this.state.clientes[h].nombre+' '+this.state.clientes[h].apellido
						
					}
					
					
				}
				
				
				if(empleado!==undefined && empleado!=="" && empleado!==null){
				

									if(viaje[k].total!==undefined){
										
										
										newViajes.push({
											key:k,
											cliente:cliente,
											empleado:empleado,
											distancia:viaje[k].distancia,
											fechaBajada:(viaje[k].fechaBajada!==undefined)?viaje[k].fechaBajada.substring(0,10):"",
											pago:viaje[k].pago,
											total:'$'+viaje[k].total,
											lugar:viaje[k].lugar
					
										})
										
										
										
									}
				
										
					
					
				}
				

				
			}
			this.setState({viajes:newViajes})
			
			
		}
	}
	errDataViajes=(err)=>{
	
		console.log(err);
	
	}
	
	gotDataEmpleados=(data)=>{
	
		let newEmpledos=[]
		
		if(data.val()!==null){
			
			let empleado=data.val();
			let keys=Object.keys(empleado);
			
			
			for(let i=0;i<keys.length;i++){
				
				
				let k=keys[i]
				
				
				newEmpledos.push({
					key:k,
					correo:empleado[k].correo,
					dui:empleado[k].dui,
					direccion:empleado[k].direccion,
					edad:empleado[k].edad,
					estado:empleado[k].estado,
					licencia:empleado[k].licencia,
					nombre:empleado[k].nombre

				})
				
			}
			this.setState({condutores:newEmpledos});
			this.clientesRef.once('value',this.gotDataClientes,this.errDataClientes);
			
		}
		

	
	}
	errDataEmpleados=(err)=>{
		
		console.log(err);
	}
	
	gotDataClientes=(data)=>{
	
		let newClientes=[]
		
		
		if(data.val()!==null){
			
			let cliente=data.val();
			let keys=Object.keys(cliente);
			
			
			for(let i=0;i<keys.length;i++){
				
				
				let k=keys[i];
				
				
				newClientes.push({
					key:k,
					nombre:cliente[k].nombre,
					apellido:cliente[k].apellido
					
				})
				
			}
			this.setState({clientes:newClientes})
			this.viajesRef.once('value',this.gotDataViajes,this.errDataViajes);	
		}
	
		
	}
	errDataClientes=(err)=>{
		
		console.log(err);
		
	}
	

	
	render(){
		
		return(
		
		
				<div className="reporte_viajes_conductores container">
	
					<h1 className="titulo">Viajes por conductor</h1>
	
	
					<BootstrapTable data={ this.state.viajes }
						 ref='table'			 
						 pagination={ true }
						 search={ true }
						 hover
						 >
						 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
						 <TableHeaderColumn dataField='cliente'  dataSort={true}  >Cliente</TableHeaderColumn>
						 <TableHeaderColumn dataField='empleado'  dataSort={true}  >Empleado</TableHeaderColumn>						 
						 <TableHeaderColumn dataField='fechaBajada'  dataSort={true}  dataAlign='center'>Fecha</TableHeaderColumn>
						 <TableHeaderColumn dataField='pago'  dataSort={true}  dataAlign='center'>Pago</TableHeaderColumn>
						 <TableHeaderColumn dataField='distancia'  dataSort={true}  dataAlign='center'>Distancia</TableHeaderColumn>
						 <TableHeaderColumn dataField='total'  dataSort={true}  dataAlign='center'>Total</TableHeaderColumn>
						 <TableHeaderColumn dataField='lugar'  dataSort={true}  dataAlign='center'  >Lugar</TableHeaderColumn>
						 
					</BootstrapTable>


	
				</div>
		
		);		
	}	
}

export default ReporteViajesConductores;


// WEBPACK FOOTER //
// ./src/Components/Perfil_Socios/ReporteViajesConductores.jsx